import type { IconData } from "@loot-os/icons/types";
import { cn } from "../foundations/cn.js";
import { cardStyles } from "./Card.styles.js";
import { Icon } from "./Icon.js";

export interface FeatureCardProps {
  icon: IconData;
  /** One promise, in a few words: "Ships in 48 hours". */
  title: string;
  /** One line of detail. */
  detail: string;
  className?: string;
}

/** One promise in a grid of them: an icon in an accent well, a headline and a detail line. */
export function FeatureCard({ icon, title, detail, className }: FeatureCardProps) {
  return (
    <div className={cn(cardStyles({ radius: "xl" }), "flex flex-col gap-4 p-5", className)}>
      <span className="flex size-10 items-center justify-center rounded-lg bg-accent-subtle text-accent-text">
        <Icon icon={icon} size={20} />
      </span>
      <span className="flex flex-col gap-1">
        <span className="font-body text-heading-h3 text-text-primary">{title}</span>
        <span className="font-body text-body-b2 text-text-secondary">{detail}</span>
      </span>
    </div>
  );
}
